module.exports = __webpack_public_path__ + "img/qrcode_dy.5993187f.jpg";